import React from "react";
import { useNavigate } from "react-router-dom";
import Lottie from "lottie-react";
import Swal from "sweetalert2";

import capsuleAnim from "../assets/capsule.json";
import stethoscopeAnim from "../assets/stethoscope.json";
import supplementAnim from "../assets/supplements.json";
import heartAnim from "../assets/Giving Heart, Heart Animation.json";
import beautyAnim from "../assets/Beauty.json";
import comingSoonAnim from "../assets/coming-soon.json";
import { BsHeadset } from "react-icons/bs";

function PublicCustomerDashboard() {
  const navigate = useNavigate();

  const openMedicineTypeSelector = async () => {
    await Swal.fire({
      title: "Choose Medicine Type",
      html: `
        <div style="display:flex;flex-direction:column;gap:15px;margin-top:20px;">
          <button id="genericBtn" type="button"
            style="background:linear-gradient(135deg,#16a34a,#22c55e);padding:18px;border:0;border-radius:18px;color:white;cursor:pointer;text-align:left;box-shadow:0 5px 15px rgba(0,0,0,0.15);width:100%;">
            <div style="font-size:20px;font-weight:bold;">💊 Generic Medicines</div>
            <div style="margin-top:5px;font-size:14px;opacity:0.9;">Affordable alternatives</div>
          </button>
          <button id="brandedBtn" type="button"
            style="background:linear-gradient(135deg,#2563eb,#4f46e5);padding:18px;border:0;border-radius:18px;color:white;cursor:pointer;text-align:left;box-shadow:0 5px 15px rgba(0,0,0,0.15);width:100%;">
            <div style="font-size:20px;font-weight:bold;">🏥 Branded / Ethical</div>
            <div style="margin-top:5px;font-size:14px;opacity:0.9;">Prescribed brands</div>
          </button>
        </div>
      `,
      showConfirmButton: false,
      showCloseButton: true,
      width: 380,
      background: "#ffffff",
      didOpen: () => {
        document.getElementById("genericBtn")?.addEventListener("click", () => {
          Swal.close();
          navigate("/public-generic");
        });
        document.getElementById("brandedBtn")?.addEventListener("click", () => {
          Swal.close();
          navigate("/public-shop");
        });
      },
    });
  };

  const cardHover = (event, scale) => {
    event.currentTarget.style.transform = `scale(${scale})`;
  };

  return (
    <div style={styles.page}>


<style>{`
  .public-header {
    box-sizing: border-box;
  }

  .public-brand-text {
    min-width: 0;
    flex: 1;
  }

  .public-brand-name {
    overflow-wrap: break-word;
  }

  .public-auth-buttons button {
    min-height: 44px;
  }

  @media (max-width: 600px) {
    .public-header {
      flex-direction: column !important;
      align-items: stretch !important;
      gap: 16px !important;
      padding: 16px !important;
    }

    .public-brand {
      width: 100%;
      align-items: flex-start !important;
      gap: 12px !important;
    }

    .public-brand-name {
      font-size: 19px !important;
      line-height: 1.3 !important;
    }

    .public-brand-subtitle {
      font-size: 13px !important;
      line-height: 1.4 !important;
    }

    .public-auth-buttons {
      display: grid !important;
      grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
      width: 100%;
      gap: 10px !important;
    }

    .public-auth-buttons button {
      box-sizing: border-box;
      width: 100%;
      min-width: 0;
      padding: 12px 8px !important;
      font-size: 14px !important;
      white-space: normal !important;
    }
  }

  @media (max-width: 360px) {
    .public-brand-name {
      font-size: 17px !important;
    }

    .public-auth-buttons {
      grid-template-columns: 1fr;
    }
  }
`}</style>



      {/* Public header: no private user/cart/notification requests */}
        {/* Banner */}
      <section style={styles.banner}>
        <div style={{ textAlign: "center" }}>
          <h1 style={styles.bannerTitle}>PharmaHelp</h1>
         <p style={styles.bannerSubtitle}>Your Trusted Online Pharmacy</p>
          
          <div style={{ marginTop: 6 }}>🎁 Up to 70% OFF • ✅ Genuine Products</div>
        </div>
      </section>

<header className="public-header" style={styles.header}>
  <div className="public-brand" style={styles.brand}>
    <div style={styles.logoMark}>✚</div>

    <div className="public-brand-text">
      <h2
        className="public-brand-name"
        style={styles.brandName}
      >
        Medicines delivered to your doorstep
      </h2>

   
    </div>
  </div>

  <div className="public-auth-buttons" style={styles.authButtons}>
    <button
      type="button"
      style={styles.loginButton}
      onClick={() => navigate("/login")}
    >
      Login
    </button>

    <button
      type="button"
      style={styles.signupButton}
      onClick={() => navigate("/signup-customer")}
    >
      Create Account
    </button>
  </div>
</header>


    

      {/* Public category landing cards */}
      <section style={styles.grid}>
        <button
          type="button"
          style={styles.card}
          onClick={openMedicineTypeSelector}
          onMouseEnter={(e) => cardHover(e, 1.03)}
          onMouseLeave={(e) => cardHover(e, 1)}
        >
          <Lottie animationData={capsuleAnim} style={{ height: 80, width: 80, background: "transparent" }} />
          <p style={styles.cardText}>Shop Medicines</p>
        </button>

        <button
          type="button"
          style={styles.card}
          onClick={() => navigate("/public-Surgical")}
          onMouseEnter={(e) => cardHover(e, 1.03)}
          onMouseLeave={(e) => cardHover(e, 1)}
        >
          <Lottie animationData={stethoscopeAnim} style={{ height: 70, width: 70, background: "transparent" }} />
          <p style={styles.cardText}>Surgical Items</p>
        </button>

        <button
          type="button"
          style={styles.card}
          onClick={() => navigate("/public/Health%20supplements")}
          onMouseEnter={(e) => cardHover(e, 1.03)}
          onMouseLeave={(e) => cardHover(e, 1)}
        >
          <Lottie animationData={supplementAnim} style={{ height: 70, width: 70, background: "transparent" }} />
          <p style={styles.cardText}>Supplements</p>
        </button>

        <button
          type="button"
          style={styles.card}
          onClick={() => navigate("/public/Intimate%20care")}
          onMouseEnter={(e) => cardHover(e, 1.03)}
          onMouseLeave={(e) => cardHover(e, 1)}
        >
          <Lottie animationData={heartAnim} style={{ height: 70, width: 70, background: "transparent" }} />
          <p style={styles.cardText}>Intimate Care</p>
        </button>

        <button
          type="button"
          style={styles.card}
          onClick={() => navigate("/public/Skin%20and%20hair%20Products")}
          onMouseEnter={(e) => cardHover(e, 1.03)}
          onMouseLeave={(e) => cardHover(e, 1)}
        >
          <Lottie animationData={beautyAnim} style={{ height: 70, width: 70, background: "transparent" }} />
          <p style={styles.cardText}>Hair &amp; Skin</p>
        </button>

        <div style={{ ...styles.card, cursor: "default" }}>
          <Lottie animationData={comingSoonAnim} style={{ height: 70, width: 70, background: "transparent" }} />
          <p style={styles.cardText}>More Categories Coming Soon</p>
        </div>
      </section>

      {/* Public support contact */}
      <section style={styles.helpBox}>
        <a href="tel:6395050131" style={styles.contactCard}>
          <div style={styles.iconCircle}>
            <BsHeadset size={24} />
          </div>
          <div>
            <div style={styles.contactTitle}>General Support</div>
            <div style={styles.contactNumber}>6395050131</div>
          </div>
        </a>
      </section>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    boxSizing: "border-box",
    padding: 16,
    paddingTop: "calc(20px + env(safe-area-inset-top))",
    paddingBottom: "calc(30px + env(safe-area-inset-bottom))",
    background: "linear-gradient(135deg, #f5f7fb, #e4ecf7)",
    color: "#111",
    fontFamily: "system-ui, sans-serif",
  },
  header: {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: 12,
  marginBottom: 20,
  padding: "12px 16px",
  background: "#FFFFFF",
  borderRadius: 16,
  boxShadow: "0 3px 12px rgba(15, 35, 75, 0.06)",
},
brand: {
  display: "flex",
  alignItems: "center",
  gap: 10,
  minWidth: 0,
},
logoMark: {
  width: 42,
  height: 42,
  borderRadius: 12,
  background: "linear-gradient(135deg, #2563EB, #123A8C)",
  color: "#FFFFFF",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: 27,
  fontWeight: 800,
  flexShrink: 0,
},
brandName: {
  margin: 0,
  color: "#10234A",
  fontSize: 21,
  fontWeight: 800,
  lineHeight: 1.2,
},
brandSubtitle: {
  margin: "4px 0 0",
  color: "#64748B",
  fontSize: 11,
},

  welcome: {
    fontSize: 12,
    color: "#64748b",
    margin: 0,
  },
  name: {
    margin: "3px 0 0",
    fontWeight: 800,
  },
  authButtons: {
  display: "flex",
  alignItems: "center",
  gap: 10,
  flexShrink: 0,
},
  loginButton: {
  border: "1px solid #2563EB",
  background: "#FFFFFF",
  color: "#1D4ED8",
  padding: "11px 18px",
  borderRadius: 10,
  fontSize: 14,
  fontWeight: 700,
  whiteSpace: "nowrap",
  cursor: "pointer",
},
  signupButton: {
  border: "1px solid #1769E0",
  background: "linear-gradient(135deg, #2878F0, #1749C7)",
  color: "#FFFFFF",
  padding: "11px 18px",
  borderRadius: 10,
  fontSize: 14,
  fontWeight: 700,
  whiteSpace: "nowrap",
  cursor: "pointer",
  boxShadow: "0 4px 10px rgba(37, 99, 235, 0.20)",
},
  banner: {
    background: "linear-gradient(135deg, #2563eb 0%, #1d4ed8 60%, #0f172a 100%)",
    color: "#fff",
    padding: 24,
    borderRadius: 20,
    marginBottom: 20,
    boxShadow: "0 8px 25px rgba(37,99,235,0.25)",
  },
  bannerTitle: {
    margin: 0,
    fontSize: 32,
    fontWeight: 800,
  },
  bannerSubtitle: {
    marginTop: 6,
    marginBottom: 0,
    opacity: 0.9,
    fontSize: 14,
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    gap: 15,
    marginBottom: 20,
  },
  card: {
    appearance: "none",
    width: "100%",
    boxSizing: "border-box",
    border: "none",
    background: "rgba(255,255,255,0.92)",
    backdropFilter: "blur(10px)",
    padding: 20,
    borderRadius: 18,
    textAlign: "center",
    color: "#111",
    boxShadow: "0 6px 15px rgba(0,0,0,0.08)",
    cursor: "pointer",
    transition: "transform 0.3s ease",
    font: "inherit",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: 125,
  },
  cardText: {
    marginTop: 10,
    marginBottom: 0,
    fontSize: 15,
    fontWeight: 600,
  },
  helpBox: {
    display: "flex",
    flexDirection: "column",
    gap: 12,
  },
  contactCard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 18,
    padding: 20,
    textDecoration: "none",
    background: "#fff",
    borderRadius: 18,
    color: "#111",
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
  },
  iconCircle: {
    width: 50,
    height: 50,
    borderRadius: "50%",
    background: "linear-gradient(135deg,#2563eb,#1d4ed8)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    flexShrink: 0,
  },
  contactTitle: {
    fontSize: 14,
    color: "#64748b",
    fontWeight: 600,
  },
  contactNumber: {
    fontSize: 20,
    fontWeight: 700,
    color: "#2563eb",
  },
};

export default PublicCustomerDashboard;
